<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001116')"
						paramKey="bomType"
						:options="bomInfo"
						:propData="searchParams.bomType"
						:showAll="false"
						@commChange="changebomType"
					/>
				</el-col>
				<el-col :span="4">
					<!--partNm-->
					<search-input :label="getMessage_('QWCC000956')" paramKey="partNm" @commInput="changebomType" :propData="searchParams.partNm" />
				</el-col>
			</el-row>
			<template slot="button">
				<!--조회-->
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/BomInfo/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import SelectCombo from '@qms/Components/SelectCombo.vue';
export default {
	props: {
		scrId: { type: String, default: '' },
		showAll: {}
	},

	data() {
		return {
			searchAplcDdDt: ['', ''],
			searchDcsnDdDt: ['', '']
		};
	},
	components: { SearchInput, SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		async changebomType(param) {
			await this.setSearchParam_(param);
		},
		searchList() {
			this.$sf_toggleLoading(true);
			this.getBomInfo_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'bomInfo', codeType: 'BOM_TYPE' }); //BOM유형

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
